<template>

    <div>
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="owner-tabs">
            <b-tabs v-model="activeTab" content-class="mt-3">
                <b-tab :title="$ml.get('companyManagement')"
                       v-if="showCompanyTab">
                    <tabCompany></tabCompany>
                </b-tab>
                <b-tab :title="$ml.get('sites')">
                    <tabSites></tabSites>
                </b-tab>
                <b-tab :active="analyticActiveBool" :title="$ml.get('questionsAndAnalytics')">
                    <tabAnalytics></tabAnalytics>
                </b-tab>
				<b-tab :title="$ml.get('tab_Map')" @click="$router.push({name: 'MapDashboard'})"></b-tab>
            </b-tabs>
        </div>
    </div>

</template>

<script>

    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import tabSites from '@/components/owner-management/tabs/tabSites';
    import tabCompany from '@/components/owner-management/tabs/tabCompany';
    import tabAnalytics from '@/components/owner-management/tabs/tabAnalytics';
    import logAnalyticsEvent from '@/helpers/analytics'
    import customModalDialog from '@/components/widgets/customModalDialog';

    import errorMixin from '@/mixins/errorMixin';
    import questionMixin from '@/mixins/questionMixin';
    import mapMixin from '@/mixins/mapMixin';

    export default {
        mixins: [errorMixin, mixin, questionMixin, mapMixin],
        data() {
            return {
                pageLoad: true,
                showCompanyTab: false,
                organization: {},
                analyticActiveBool: false,
                customModalSettings: {},
            }
        },

        components: {
            tabSites,
            tabCompany,
            tabAnalytics,
            customModalDialog,
        },

        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo,
            }),

            ...mapGetters({
                getActiveTab: 'owner/getActiveTab',
                isUserOwner: 'auth/isUserOwner',
                isUserOrgManager: 'auth/isUserOrgManager',
                hasOwnPlace: 'auth/hasOwnPlace',
                hasOrgManagerPlace: 'auth/hasOrgManagerPlace',
                orgManagerPlaces: 'auth/orgManagerPlaces',
                isUserSiteManager: 'auth/isUserSiteManager',
            }),

            activeTab: {
                get: function () {
                    let realIndex = this.getActiveTab
                    if(!this.showCompanyTab) {
                        realIndex--
                    }
                    return realIndex
                },
                set: function (newValue) {
                    let realIndex = newValue
                    if(!this.showCompanyTab) {
                        realIndex++
                    }
                    this.setActiveTab(realIndex)
                    return newValue
                }
            }

        },

        async beforeMount() {
            if (this.$route.params) {
                if (this.$route.params.analyticActiveBool) {
                    this.analyticActiveBool = true
                }
            }

            try {
                this.showCompanyTab = (this.userInfo.role == 'owner' && this.userInfo.organization.all_places.length > 1)
                || (this.userInfo.organizations.length && this.userInfo.organizations[0].all_places.length > 1)
            }catch (e) {}
        },

        async mounted() {
            console.log(`dsf_location:${location.href}`)
            if (location.href.includes('registered')) {
                logAnalyticsEvent(`owner_dashboard_registered`)
                logAnalyticsEvent('CompleteRegistration', null, true)
            }
            if (this.$route.params.status) {
                history.replaceState(
                    {},
                    null,
                    location.origin + '/' + this.$route.path.split('/')[1]
                )
            }
            await this.fetchUserInfo()
            if (((this.isUserOwner && this.hasOwnPlace)
                || (this.hasOrgManagerPlace && this.orgManagerPlaces.length > 1)
                || (this.isUserSiteManager))
                && this.getUnlinkedQuestion()
            ) {
                this.customModalSettings = {
                    addBusinessPopup: true,
                    hideOkButton: true,
                    selectBusinessFlowSettings: {
                        businessFlow: false,
                        siteFlow: false,
                        addressFlow: false,
                        siteSelectorFlow: true,
                        subtitle: this.translate('bflow_BusinesConnectQuestion', [this.getUnlinkedQuestion().value]),
                        onOkHandler: this.onChooseSiteForQuestionSelectionCompleted,
                    }
                }
            }
        },

        methods: {
            ...mapMutations({
                setActiveTab: 'owner/setActiveTab',
            }),
            ...mapActions({
                connectQuestionToManager: 'question/connectQuestionToManager',
                fetchUserInfo: 'auth/fetchUserInfo',
            }),

            async onChooseSiteForQuestionSelectionCompleted(siteInfo) {
                this.customModalSettings = {}
                try {
                    let response = await this.connectQuestionToManager({
                        questionId: this.getUnlinkedQuestion().id,
                        siteUid: siteInfo.place_id
                    })
                    console.log(`success connectQuestionToManager`)
                    this.clearUnlinkedQuestion()
                    this.$store.commit('owner/setOwner', false)
                    this.customModalSettings = {
                        message: this.translate('bflow_BusinesConnectQuestionSuccess'),
                        icon: 'ic_allow.svg'
                    }
                    await this.fetchUserInfo()
                } catch (e) {
                    console.log(`error connectQuestionToManager`, e)
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            },

        }
    }

</script>
